import React, { useState, useEffect, useCallback } from "react";
import { useAuth } from "../../context/AuthContext.js";
import api from "../../api/api.js";
import Spinner from "../../components/ui/Spinner.js";
import MessageBox from "../../components/ui/MessageBox.js";
import Button from "../../components/ui/Button.js";
import PurchaseOrderItems from "./PurchaseOrderItems.js";

const PurchaseOrderNewItem = ({ setView, context }) => {
  const { user } = useAuth();
  const [orderDetails, setOrderDetails] = useState(null);
  const [purchaseOrderItems, setPurchaseOrderItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  // Fetch order data
  const fetchOrderData = useCallback(
    async (showSpinner = true) => {
      if (showSpinner) setLoading(true);
      try {
        const orderData = await api.getPurchaseOrderForEdit(context.id);

        if (orderData?.Table?.length > 0) {
          setOrderDetails({
            ...orderData.Table[0],
            Table2: orderData.Table2 || [],
          });
        }
        setPurchaseOrderItems(orderData?.Table1 || []);
      } catch (err) {
        console.error(err);
        setError("Failed to load order data.");
      } finally {
        if (showSpinner) setLoading(false);
      }
    },
    [context.id]
  );

  useEffect(() => {
    fetchOrderData();
  }, [fetchOrderData]);

  if (loading) return <Spinner />;
  if (error) return <MessageBox message={error} />;

  return (
    <div className="w-full h-full bg-white">
      <div className="p-2">
        {/* Title */}
        <h1 className="text-xl font-bold text-center">
          Add Items to Purchase Order
          <div>
            #{context.id} / {context.customer?.Vname}
          </div>
        </h1>

        {success && (
          <MessageBox
            message={success}
            type="success"
            onDismiss={() => setSuccess("")}
          />
        )}

        <PurchaseOrderItems
          orderId={context.id}
          customerId={context.customerId}
          orderDate={context.orderDate}
          items={purchaseOrderItems}
          user={user}
          setError={setError}
          setSuccess={setSuccess}
          refetchData={() => fetchOrderData(false)}
        />

        <div className="flex justify-end pt-4 mt-4 border-t">
          <Button
            type="button"
            onClick={() => setView("purchaseorders")}
            className="bg-blue-500 hover:bg-blue-600 px-3 py-1 text-sm"
          >
            Back to Purchase Orders
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PurchaseOrderNewItem;




// import React, { useState, useEffect, useCallback } from "react";
// import { useAuth } from "../../context/AuthContext.js";
// import api from "../../api/api.js";
// import Spinner from "../../components/ui/Spinner.js";
// import MessageBox from "../../components/ui/MessageBox.js";
// import Button from "../../components/ui/Button.js";
// import PurchaseOrderItems from "./PurchaseOrderItems.js";

// const PurchaseOrderNewItem = ({ setView, context }) => {
//   const { user } = useAuth();
//   const [orderDetails, setOrderDetails] = useState(null);
//   const [purchaseOrderItems, setPurchaseOrderItems] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
//   const [success, setSuccess] = useState("");

//   // Fetch order data
//   const fetchOrderData = useCallback(
//     async (showSpinner = true) => {
//       if (showSpinner) setLoading(true);
//       try {
//         const orderData = await api.getPurchaseOrderForEdit(context.id);

//         if (orderData?.Table?.length > 0) {
//           setOrderDetails({
//             ...orderData.Table[0],
//             Table2: orderData.Table2 || [],
//           });
//         }
//         setPurchaseOrderItems(orderData?.Table1 || []);
//       } catch (err) {
//         console.error(err);
//         setError("Failed to load order data.");
//       } finally {
//         if (showSpinner) setLoading(false);
//       }
//     },
//     [context.id]
//   );

//   useEffect(() => {
//     fetchOrderData();
//   }, [fetchOrderData]);

//   if (loading) return <Spinner />;
//   if (error) return <MessageBox message={error} />;

//   return (
//     <div className="w-full h-full bg-white">
//       <div className="p-2">
//         {/* Title */}
//         <h1 className="text-xl font-bold text-center">
//           Add Items to Purchase Order
//           <div>
//             #{context.id} / {context.customer?.Vname}
//           </div>
//         </h1>

//         {success && (
//           <MessageBox
//             message={success}
//             type="success"
//             onDismiss={() => setSuccess("")}
//           />
//         )}

//         <PurchaseOrderItems
//           orderId={context.id}
//           customerId={context.customerId}
//           orderDate={context.orderDate}
//           items={purchaseOrderItems}
//           user={user}
//           setError={setError}
//           setSuccess={setSuccess}
//           refetchData={() => fetchOrderData(false)}
//         />

//         <div className="flex justify-end pt-4 mt-4 border-t">
//           <Button
//             type="button"
//             onClick={() => setView("purchaseorders")}
//             className="bg-blue-500 hover:bg-blue-600 px-3 py-1 text-sm"
//           >
//             Back to Purchase Orders
//           </Button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default PurchaseOrderNewItem;

